/**
 * Public application entry point.
 *
 * Bootstraps the auth-only SPA that handles login, registration,
 * password reset, email verification, two-factor, and third-party
 * app authorization.  Served from the root path (`/`).
 *
 * 1. Initialises the Auth module (reads token from localStorage).
 * 2. Loads the server configuration (app name + version).
 * 3. Mounts the public root Svelte component.
 */
import { mount } from 'svelte';
import App from './App.svelte';
import { initialize } from '../Auth';
import { loadConfiguration } from '../AppConfiguration';

/* Legacy v1 URL rewrites (e.g. /login/?verification_url=…) run inline in
   index.html before this module loads — see the <script> tag there. */

/* Auth init is async — we fire it and let App.svelte react to store changes. */
initialize();
loadConfiguration();

const app = mount(App, {
	target: document.getElementById('app')!
});

/** Public (auth) SPA application instance. */
export default app;
